import { useTranslation } from "react-i18next";

const Marketing = () => {

    const { t } = useTranslation();

    return (
        <>
            <div>
                <h4>{t("serviceDetailPage.marketing.contentTitle1")}</h4>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.marketing.contentText1") as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.marketing.contentText2") as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.marketing.contentText3") as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.marketing.contentText4") as string}}></p>
            </div>
            <div>
                <h4>{t("serviceDetailPage.marketing.contentTitle2")}</h4>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.marketing.contentText5") as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.marketing.contentText6") as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.marketing.contentText7") as string}}></p>
                <ul>
                    <li>{t("serviceDetailPage.marketing.listItem1")}</li>
                    <li>{t("serviceDetailPage.marketing.listItem2")}</li>
                    <li>{t("serviceDetailPage.marketing.listItem3")}</li>
                    <li>{t("serviceDetailPage.marketing.listItem4")}</li>
                    <li>{t("serviceDetailPage.marketing.listItem5")}</li>
                    <li>{t("serviceDetailPage.marketing.listItem6")}</li>
                    <li>{t("serviceDetailPage.marketing.listItem7")}</li>
                    <li>{t("serviceDetailPage.marketing.listItem8")}</li>
                    <li>{t("serviceDetailPage.marketing.listItem9")}</li>
                    <li>{t("serviceDetailPage.marketing.listItem10")}</li>
                </ul>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.marketing.contentText8") as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.marketing.contentText9") as string}}></p>
            </div>
            <div>
                <h4>{t("serviceDetailPage.marketing.contentTitle3")}</h4>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.marketing.contentText10") as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.marketing.contentText11") as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.marketing.contentText12") as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.marketing.contentText13") as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.marketing.contentText14") as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.marketing.contentText15") as string}}></p>
                <p dangerouslySetInnerHTML={{ __html: t("serviceDetailPage.marketing.contentText16") as string}}></p>
            </div>
        </>
    )
}

export default Marketing;